import * as C from '@/consts'
import * as a from '@/libs/a'
import logo from '@/assets/card-brands/logo_mastercard.gif'

export default {
  // ブランドコード
  code: C.BRAND_MASTER,

  // ブランド判定
  match (number) {
    // 510000 - 559999, 222100 - 272099
    const prefix = (number + '000000').slice(0, 6) | 0

    const result =
      a.between(prefix, 510000, 559999) ||
      a.between(prefix, 222100, 272099) ||
      false
    return result
  },

  // カード番号のパターン
  pattern: [4, 4, 4, 4],

  // ロゴ
  logo
}
